import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  Card,
  Button,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  useLocation
} from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller, Resolver } from "react-hook-form";
import { makeStyles } from '@mui/styles';
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import SelectDropdown from "../common/FormSelectDropdown";
import TextInput from "../common/TextInput";
import { errorToast, successToast, warningToast } from "../../utils/toast";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { convertToObject } from "typescript";
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { useLoader } from "../../../pages/LoaderContext";
import { useProjectApiClient } from "../../Services/api/projectService"
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import { projectVersion } from "config/navConfig";
import { useKPISummaryApiClient } from "v2/Services/api/kpiSummaryService";
import FileUpload from "../common/FileUpload";
import UploadList from "v2/components/common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";
import RefreshIcon from "@mui/icons-material/Refresh";


const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});


const schema = yup.object().shape({
  lcsScope: yup.mixed().nullable(),
  lcsCondition: yup.mixed().nullable(),
  previousLcsCondition: yup.mixed().nullable(),
  lcsStatus: yup.mixed().nullable(),
  lcsComment: yup.string().nullable(),

  cptScope: yup.mixed().nullable(),
  cptCondition: yup.mixed().nullable(),
  previouscptCondition: yup.mixed().nullable(),
  cptStatus: yup.mixed().nullable(),
  cptComment: yup.string().nullable(),

  d2dScope: yup.mixed().nullable(),
  d2dCondition: yup.mixed().nullable(),
  d2dStatus: yup.mixed().nullable(),
  d2dComment: yup.string().nullable(),

  ltpcScope: yup.mixed().nullable(),
  ltpcStatus: yup.mixed().nullable(),
  ltpcComment: yup.string().nullable(),
  ltpcLaunchYear: yup.mixed().nullable(),
  ltpcLaunchWeek: yup.mixed().nullable(),

  dfmcScope: yup.mixed().nullable(),
  dfmcCondition: yup.mixed().nullable(),
  previousDfmcCondition: yup.mixed().nullable(),
  dfmcStatus: yup.mixed().nullable(),
  dfmcComment: yup.string().nullable(),
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const KpiSummaryForm: React.FC = () => {
  const location = useLocation();
  const { getProjectDetails, getRequiredField, publishProjectOnSave, uploadProjectFile } = useProjectApiClient();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const {
    getKPISInScopeOptions,
    getTechnicalScopeOfChange,
    getESLowCostSuppliersinScope,
    getCptCompliance,
    getDesignToDistributeComplete,
    getSupplierUtilisation,
    getLaunchYears,
    getWeeks,
    getKPISCondition,
    getKpiSummaryById,
    getESManufacturingComplete,
    createKpiSummary,
  } = useKPISummaryApiClient();
  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const { loading, setLoading } = useLoader();
  const classes = useStyles();

  const [isExisting, setIsExisting] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true);

  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [initialFormData, setInitialFormData] = useState<any>({
    lcsScopes: '',
    lcsConditions: '',
    lcsStatuses: '',
    lcsComment: '',

    cptScopes: '',
    cptConditions: '',
    cptStatuses: '',
    cptComment: '',

    d2dScopes: '',
    d2dConditions: '',
    d2dStatuses: '',
    d2dComment: '',

    ltpcScopes: '',
    ltpcConditions: '',
    ltpcLaunchYear: '',
    ltpcLaunchWeek: '',
    ltpcStatuses: '',
    ltpcComment: '',

    dfmcScopes: '',
    dfmcConditions: '',
    dfmcStatuses: '',
    dfmcComment: '',

    freightType: '',
    shipmentRequirement: '',
    designToDistribute: '',
    whRequirement: '',
    risk: '',
    comment: ''
  });


  const [formData, setFormData] = useState({
    lcsScopes: '',
    lcsConditions: '',
    lcsStatuses: '',
    lcsComment: '',

    cptScopes: '',
    cptConditions: '',
    cptStatuses: '',
    cptComment: '',

    d2dScopes: '',
    d2dConditions: '',
    d2dStatuses: '',
    d2dComment: '',

    ltpcScopes: '',
    ltpcConditions: '',
    ltpcLaunchYear: '',
    ltpcLaunchWeek: '',
    ltpcStatuses: '',
    ltpcComment: '',

    dfmcScopes: '',
    dfmcConditions: '',
    dfmcStatuses: '',
    dfmcComment: '',

    freightType: '',
    shipmentRequirement: '',
    designToDistribute: '',
    whRequirement: '',
    risk: '',
    comment: ''
  })


  interface KpiFormValues {
    lcsScope?: string | null;
    lcsCondition?: string | null;
    previousLcsCondition?: string | null;
    lcsStatus?: string | null;
    lcsComment?: string | null;
    lcsKpiId?: number | null;

    cptScope?: string | null;
    cptCondition?: string | null;
    previouscptCondition?: string | null;
    cptStatus?: string | null;
    cptComment?: string | null;
    cptKpiId?: number | null;

    d2dScope?: string | null;
    d2dCondition?: string | null;
    d2dStatus?: string | null;
    d2dComment?: string | null;
    d2dKpiId?: number | null;

    ltpcScope?: string | null;
    ltpcCondition?: string | null;
    ltpcStatus?: string | null;
    ltpcComment?: string | null;
    ltpcLaunchYear?: string | number | null;
    ltpcLaunchWeek?: string | number | null;
    ltpcLaunchQuarter?: string | number | null;
    ltpcKpiId?: number | null;

    dfmcScope?: string | null;
    dfmcCondition?: string | null;
    previousDfmcCondition?: string | null;
    dfmcStatus?: string | null;
    dfmcComment?: string | null;
    dfmcKpiId?: number | null;
  }

  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<KpiFormValues>({
    resolver: yupResolver(schema) as unknown as Resolver<KpiFormValues, any>,
    defaultValues: {},
  });
  // --- Option mappers ---  
  const mapOptions = (data: any[] = []) =>
    data.map((i: any) => ({
      key: (i.Lookup_Key ?? i.key)?.toString(),
      value: i.Valuez ?? i.value,
    }));

  const mapCptStatuses = (data: any[] = []) =>
    data.map((i) => ({ key: i.Status_Key?.toString(), value: i.Status_Name }));

  const mapLaunchYears = (data: any[] = []) =>
    data.map((i) => ({ key: i.launchYears_key?.toString(), value: i.launchYears_value }));

  const mapLaunchWeek = (data: any) => {
    if (!data) return [];
    if (Array.isArray(data)) {
      return data.map((w: any) => ({
        key: String(w.Launch_Week),
        value: w.Launch_WeekName,
      }));
    }
    // handle object with "launchWeeks" property
    if (data.launchWeeks && Array.isArray(data.launchWeeks)) {
      return data.launchWeeks.map((w: any) => ({
        key: String(w.Launch_Week),
        value: w.Launch_WeekName,
      }));
    }
    return [];
  };



  // --- Dropdown states ---
  const [lcsScopes, setLcsScopes] = useState<any[]>([]);
  const [lcsConditions, setLcsConditions] = useState<any[]>([]);
  const [lcsStatuses, setLcsStatuses] = useState<any[]>([]);

  const [cptScopes, setCptScopes] = useState<any[]>([]);
  const [cptConditions, setCptConditions] = useState<any[]>([]);
  const [cptStatuses, setCptStatuses] = useState<any[]>([]);

  const [d2dScopes, setD2dScopes] = useState<any[]>([]);
  const [d2dConditions, setD2dConditions] = useState<any[]>([]);
  const [d2dStatuses, setD2dStatuses] = useState<any[]>([]);

  const [ltpcScopes, setLtpcScopes] = useState<any[]>([]);
  const [ltpcLaunchYear, setLtpcLaunchYear] = useState<any[]>([]);
  //const [ltpcLaunchWeek, setLtpcLaunchWeek] = useState<any[]>([]);
  const [ltpcStatuses, setLtpcStatuses] = useState<any[]>([]);
  const [ltpcWeeks, setLtpcWeeks] = useState<any[]>([]);


  const [dfmcScopes, setDfmcScopes] = useState<any[]>([]);
  const [dfmcConditions, setDfmcConditions] = useState<any[]>([]);
  const [dfmcStatuses, setDfmcStatuses] = useState<any[]>([]);
  const [initialLcc, setInitialLcc] = useState(false);
  const [initialCpt, setInitialCpt] = useState(false);
  const [initialDfm, setInitialDfm] = useState(false);

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);

  useEffect(() => {
    let check = JSON.stringify({
      formData,
      initialLcc,
      initialCpt,
      initialDfm,
    }) === JSON.stringify({
      formData: initialFormData,
      initialLcc: false,
      initialCpt: false,
      initialDfm: false,
    });

    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }
  }, [formData, initialLcc, initialCpt, initialDfm]);



  // --- Init form with options + payload ---
  useEffect(() => {
    const initForm = async () => {
      try {
        const [
          kpiInScope,
          kpiCondition,
          lowCostSuppliers,
          cptStatusData,
          techScope,
          d2dStatusesData,
          launchYearsData,
          launchWeekData,
          supplierUtilisation,
          dfmcStatusesData
        ] = await Promise.all([
          getKPISInScopeOptions(),
          getKPISCondition(),
          getESLowCostSuppliersinScope(),
          getCptCompliance(),
          getTechnicalScopeOfChange(),
          getDesignToDistributeComplete(),
          getLaunchYears(),
          getWeeks,
          getSupplierUtilisation(),
          getESManufacturingComplete()
        ]);

        // set dropdowns
        setLcsScopes(mapOptions(kpiInScope));
        setLcsConditions(mapOptions(kpiCondition));
        setLcsStatuses(mapOptions(lowCostSuppliers));

        setCptScopes(mapOptions(kpiInScope));
        setCptConditions(mapOptions(kpiCondition));
        setCptStatuses(mapCptStatuses(cptStatusData));

        setD2dScopes(mapOptions(kpiInScope));
        setD2dConditions(mapOptions(techScope));
        setD2dStatuses(mapOptions(d2dStatusesData));

        setLtpcScopes(mapOptions(kpiInScope));
        setLtpcStatuses(mapOptions(supplierUtilisation));
        setLtpcLaunchYear(mapLaunchYears(launchYearsData));
        //setLtpcLaunchWeek(mapLaunchWeek(launchWeekData));

        setDfmcScopes(mapOptions(kpiInScope));
        setDfmcConditions(mapOptions(kpiCondition));
        setDfmcStatuses(mapOptions(dfmcStatusesData));

        // fetch summary
        if (projectKey) {
          setLoading(true)
          const res = await getKpiSummaryById(projectKey);
          setLoading(false)
          if (Array.isArray(res)) {
            for (const item of res) {
              switch (item.KPIModuleid) {
                case 1: // LCS
                  setValue("lcsKpiId", item.KPI_Id || null);
                  setValue("lcsScope", item.Inscopeid?.toString() || null);
                  setValue("lcsCondition", item.KPIconditionid?.toString() || null);
                  setValue("previousLcsCondition", item.PreviousKPIconditionid?.toString() || null);
                  setValue("lcsStatus", item.Statusid?.toString() || null);
                  setValue("lcsComment", item.KPIComment || "");
                  break;

                case 2: // CPT
                  setValue("cptKpiId", item.KPI_Id || null);
                  setValue("cptScope", item.Inscopeid?.toString() || null);
                  setValue("cptCondition", item.KPIconditionid?.toString() || null);
                  setValue("previouscptCondition", item.PreviousKPIconditionid?.toString() || null);
                  setValue("cptStatus", item.Statusid?.toString() || null);
                  setValue("cptComment", item.KPIComment || "");
                  break;

                case 3: // D2D
                  setValue("d2dKpiId", item.KPI_Id || null);
                  setValue("d2dScope", item.Inscopeid?.toString() || null);
                  setValue("d2dCondition", item.KPIconditionid?.toString() || null);
                  setValue("d2dStatus", item.Statusid?.toString() || null);
                  setValue("d2dComment", item.KPIComment || "");
                  break;
                case 4: // LTPC
                  setValue("ltpcKpiId", item.KPI_Id || null);
                  setValue("ltpcScope", item.Inscopeid?.toString() || null);
                  setValue("ltpcStatus", item.Statusid?.toString() || null);
                  setValue("ltpcComment", item.KPIComment || "");
                  setValue("ltpcLaunchYear", item.Launch_Year?.toString() || null);
                  setValue("ltpcLaunchQuarter", item.Launch_Quarter?.toString() || null);
                  setValue("ltpcCondition", item.KPIconditionid?.toString() || "");

                  // Fetch weeks for the saved year+quarter
                  if (item.Launch_Year) {
                    try {
                      const res = await getWeeks(
                        String(item.Launch_Year),
                        String(item.Launch_Quarter || "1")
                      );

                      const weeksArray = Array.isArray(res)
                        ? res
                        : res?.launchWeeks || res?.data || [];

                      const mappedWeeks = weeksArray.map((w: any) => ({
                        key: String(w.Launch_Week),
                        value: w.Launch_WeekName,
                      }));

                      setLtpcWeeks(mappedWeeks);
                      //  Only set LaunchWeek after weeks options are ready
                      if (item.Launch_Week) {
                        const weekMatch = mappedWeeks.find(
                          (w: any) => w.key === String(item.Launch_Week)
                        );
                        if (weekMatch) {
                          setValue("ltpcLaunchWeek", weekMatch.key);
                        }
                      }
                    } catch (err) {
                      console.error("Failed to fetch weeks for LTPC:", err);
                      setLtpcWeeks([]);
                    }
                  }
                  break;

                case 5: // DFMC
                  setValue("dfmcKpiId", item.KPI_Id || null);
                  setValue("dfmcScope", item.Inscopeid?.toString() || null);
                  setValue("dfmcCondition", item.KPIconditionid?.toString() || null);
                  setValue("previousDfmcCondition", item.PreviousKPIconditionid?.toString() || null);
                  setValue("dfmcStatus", item.Statusid?.toString() || null);
                  setValue("dfmcComment", item.KPIComment || "");
                  break;
              }
            }
            for (const item of res) {
              setFormData((prev: any) => {
                const updated = { ...prev };
                switch (item.KPIModuleid) {
                  case 1: // LCS
                    updated.lcsKpiId = item.KPI_Id || null;
                    updated.lcsScopes = item.Inscopeid?.toString() || '';
                    updated.lcsConditions = item.KPIconditionid?.toString() || '';
                    updated.lcsStatuses = item.Statusid?.toString() || '';
                    updated.lcsComment = item.KPIComment || '';
                    break;

                  case 2: // CPT
                    updated.cptKpiId = item.KPI_Id || null;
                    updated.cptScopes = item.Inscopeid?.toString() || '';
                    updated.cptConditions = item.KPIconditionid?.toString() || '';
                    updated.cptStatuses = item.Statusid?.toString() || '';
                    updated.cptComment = item.KPIComment || '';
                    break;

                  case 3: // D2D
                    updated.d2dKpiId = item.KPI_Id || null;
                    updated.d2dScopes = item.Inscopeid?.toString() || '';
                    updated.d2dConditions = item.KPIconditionid?.toString() || '';
                    updated.d2dStatuses = item.Statusid?.toString() || '';
                    updated.d2dComment = item.KPIComment || '';
                    break;

                  case 4: // LTPC
                    updated.ltpcKpiId = item.KPI_Id || null;
                    updated.ltpcScopes = item.Inscopeid?.toString() || '';
                    updated.ltpcConditions = item.KPIconditionid?.toString() || '';
                    updated.ltpcStatuses = item.Statusid?.toString() || '';
                    updated.ltpcComment = item.KPIComment || '';
                    updated.ltpcLaunchYear = item.Launch_Year?.toString() || '';
                    updated.ltpcLaunchWeek = item.Launch_Week?.toString() || '';
                    break;

                  case 5: // DFMC
                    updated.dfmcKpiId = item.KPI_Id || null;
                    updated.dfmcScopes = item.Inscopeid?.toString() || '';
                    updated.dfmcConditions = item.KPIconditionid?.toString() || '';
                    updated.dfmcStatuses = item.Statusid?.toString() || '';
                    updated.dfmcComment = item.KPIComment || '';
                    break;

                  default:
                    break;
                }

                return updated;
              });
            }

            for (const item of res) {
              setInitialFormData((prev: any) => {
                const updated = { ...prev };
                switch (item.KPIModuleid) {
                  case 1: // LCS
                    updated.lcsKpiId = item.KPI_Id || null;
                    updated.lcsScopes = item.Inscopeid?.toString() || '';
                    updated.lcsConditions = item.KPIconditionid?.toString() || '';
                    updated.lcsStatuses = item.Statusid?.toString() || '';
                    updated.lcsComment = item.KPIComment || '';
                    break;

                  case 2: // CPT
                    updated.cptKpiId = item.KPI_Id || null;
                    updated.cptScopes = item.Inscopeid?.toString() || '';
                    updated.cptConditions = item.KPIconditionid?.toString() || '';
                    updated.cptStatuses = item.Statusid?.toString() || '';
                    updated.cptComment = item.KPIComment || '';
                    break;

                  case 3: // D2D
                    updated.d2dKpiId = item.KPI_Id || null;
                    updated.d2dScopes = item.Inscopeid?.toString() || '';
                    updated.d2dConditions = item.KPIconditionid?.toString() || '';
                    updated.d2dStatuses = item.Statusid?.toString() || '';
                    updated.d2dComment = item.KPIComment || '';
                    break;

                  case 4: // LTPC
                    updated.ltpcKpiId = item.KPI_Id || null;
                    updated.ltpcScopes = item.Inscopeid?.toString() || '';
                    updated.ltpcConditions = item.KPIconditionid?.toString() || '';
                    updated.ltpcStatuses = item.Statusid?.toString() || '';
                    updated.ltpcComment = item.KPIComment || '';
                    updated.ltpcLaunchYear = item.Launch_Year?.toString() || '';
                    updated.ltpcLaunchWeek = item.Launch_Week?.toString() || '';
                    break;

                  case 5: // DFMC
                    updated.dfmcKpiId = item.KPI_Id || null;
                    updated.dfmcScopes = item.Inscopeid?.toString() || '';
                    updated.dfmcConditions = item.KPIconditionid?.toString() || '';
                    updated.dfmcStatuses = item.Statusid?.toString() || '';
                    updated.dfmcComment = item.KPIComment || '';
                    break;
                  default:
                    break;
                }
                return updated;
              });
            }


          }
          fetchsProjectDetails(projectKey)

        }
      } catch (err) {
        console.error("Init form error:", err);
      }
    };
    if (projectKey) initForm();
  }, [projectKey, setValue]);


  // ----------------- FETCH WEEKS (replace your current ltpcYear/Quarter effect) -----------------
  // ensure you have this after the initForm effect

  const ltpcYear = watch("ltpcLaunchYear");
  const ltpcQuarter = watch("ltpcLaunchQuarter");

  useEffect(() => {
    const fetchWeeks = async () => {
      if (!ltpcYear) {
        setLtpcWeeks([]);
        setValue("ltpcLaunchWeek", null);
        return;
      }

      try {
        const res = await getWeeks(
          String(ltpcYear),
          String(ltpcQuarter || "1")
        );

        const weeksArray = Array.isArray(res)
          ? res
          : res?.launchWeeks || res?.data || [];

        const mappedWeeks = weeksArray.map((w: any) => ({
          key: String(w.Launch_Week),
          value: w.Launch_WeekName,
        }));

        setLtpcWeeks(mappedWeeks);

        // If selected week no longer valid, clear it
        const currentWeek = watch("ltpcLaunchWeek");
        if (currentWeek && !mappedWeeks.find((w: any) => w.key === currentWeek)) {
          setValue("ltpcLaunchWeek", null);
        }
      } catch (err) {
        console.error("Failed to fetch weeks:", err);
        setLtpcWeeks([]);
        setValue("ltpcLaunchWeek", null);
      }
    };

    fetchWeeks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ltpcYear, ltpcQuarter]);



  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved);
    }
  }

  const fetchsProjectDetails = async (projectKey: string) => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved })
        setIsDraftDisabled(data.issaved)
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  const onSubmit = async (data: any, type?: any, url?: string) => {
    let resField = await fetchRequiredField();
    if ((type === true) && (resField?.data && resField?.data.length)) {
      const groupedErrors = groupByModule(resField?.data);
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    setLoading(true);

    try {
      const payload = {
        Project_Key: projectKey?.toString(),
        issaved: true,
        modules: [
          {
            kpi_id: data.lcsKpiId || null,
            moduleKey: 1,
            scope: data.lcsScope ? parseInt(data.lcsScope) : null,
            condition: initialLcc ? data.previousLcsCondition ? String(data.previousLcsCondition) : null : data.lcsCondition ? String(data.lcsCondition) : null,
            status: data.lcsStatus ? String(data.lcsStatus) : null,
            comment: data.lcsComment || "",
          },
          {
            kpi_id: data.cptKpiId || null,
            moduleKey: 2,
            scope: data.cptScope ? parseInt(data.cptScope) : null,
            condition: initialCpt ? data.previouscptCondition ? String(data.previouscptCondition) : null : data.cptCondition ? String(data.cptCondition) : null,
            status: data.cptStatus ? String(data.cptStatus) : null,
            comment: data.cptComment || "",
          },
          {
            kpi_id: data.d2dKpiId || null,
            moduleKey: 3,
            scope: data.d2dScope ? parseInt(data.d2dScope) : null,
            condition: data.d2dCondition ? String(data.d2dCondition) : null,
            status: data.d2dStatus ? String(data.d2dStatus) : null,
            comment: data.d2dComment || "",
          },
          {
            kpi_id: data.ltpcKpiId || null,
            moduleKey: 4,
            scope: data.ltpcScope ? parseInt(data.ltpcScope) : null,
            Launch_Year: data.ltpcLaunchYear ? parseInt(data.ltpcLaunchYear) : null,
            Launch_Week: data.ltpcLaunchWeek ? parseInt(data.ltpcLaunchWeek) : null,
            condition: data.ltpcCondition ? String(data.ltpcCondition) : null,
            status: data.ltpcStatus ? String(data.ltpcStatus) : null,
            comment: data.ltpcComment || "",
          },
          {
            kpi_id: data.dfmcKpiId || null,
            moduleKey: 5,
            scope: data.dfmcScope ? parseInt(data.dfmcScope) : null,
            condition: initialDfm ? data.previousDfmcCondition ? String(data.previousDfmcCondition) : null : data.dfmcCondition ? String(data.dfmcCondition) : null,
            status: data.dfmcStatus ? String(data.dfmcStatus) : null,
            comment: data.dfmcComment || "",
          },
        ],
      };
      const res = await createKpiSummary(payload);
      if (type === true) {
        await pubLishProjectData();
        setProjectDetails({ issaved: type });
        setIsDraftDisabled(type);
      }
      if (res) successToast("KPI Summary saved");
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
      if (!type) {
        setTimeout(() => {
          navigate(
            url
              ? url
              : `${projectVersion}/project/cmoinnovationforum/${projectId}/${projectKey}`
          );
        }, 1000);
      }
    } catch (err) {
      console.error("Submit error:", err);
      errorToast("Failed to save KPI Summary");
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };
  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(false, appData.url)()
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal  
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, '')();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 10, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };

  const reloadLcsConditions = async () => {
    try {
      setInitialLcc(true)
      const data = await getKPISCondition();
      setLcsConditions(mapOptions(data));
      successToast("LCS conditions refreshed");
    } catch (err) {
      errorToast("Failed to reload LCS conditions");
    }
  };

  const reloadCptConditions = async () => {
    try {
      setInitialCpt(true)
      const data = await getKPISCondition();
      setCptConditions(mapOptions(data));
      successToast("CPT conditions refreshed");
    } catch (err) {
      errorToast("Failed to reload CPT conditions");
    }
  };

  const reloadDfmcConditions = async () => {
    try {
      setInitialDfm(true)
      const data = await getKPISCondition();
      setDfmcConditions(mapOptions(data));
      successToast("DFMC conditions refreshed");
    } catch (err) {
      errorToast("Failed to reload DFMC conditions");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "30px", borderRadius: "20px", pt: 3 }}>

          {/* Buttons - Save, Draft, Cancel */}
          <Box>
            <div className="button-top-form" style={{ display: isUpload ? 'flex' : '', justifyContent: 'space-between' }} >
              {
                isUpload ?
                  <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                  :
                  null
              }

              {
                !isUpload
                  ?
                  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                    <Grid size={4}>
                      {/* <div className="heading-sect-wts"><h2 className="title-projct-nm">Project Name</h2></div> */}
                    </Grid>
                    <Grid size={8}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ justifyContent: "end" }}
                      >
                        {
                          localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                            JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                              <Tooltip title="Upload Documents" arrow>
                                <Button
                                  onClick={() => handleClickUpload()}
                                  sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                                >
                                  <img src={uploadIcon} className="icon-wt-uplad" />
                                </Button>
                              </Tooltip>
                              :
                              <>
                              </>
                            :
                            null
                        }
                        <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                          sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button>

                        <Button
                          disabled={isDisabled || projectDetails.issaved}
                          onClick={handleFormSubmit(false, '')}
                          variant="contained"
                          sx={{
                            borderRadius: '30px',
                            px: 4,
                            py: 1,
                            textTransform: 'capitalize',
                            color: 'white !important',
                            backgroundColor: '#2a3fbf !important',
                            '&.Mui-disabled': {
                              backgroundColor: '#d9d9d9 !important',
                              color: '#5f6368 !importan t'
                            }
                          }}
                          className={classes.themeButton}
                        >
                          Draft & Continue
                        </Button>
                        <Button disabled={isDisabled} onClick={handleCancel} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: '#000' }} className={classes.cancelButton}>Cancel</Button>

                      </Stack>
                    </Grid>
                  </Grid>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>
              }



            </div>
            <br></br>
            <div className="table-list-project">
              {
                isUpload ?
                  <>
                    {/* @ts-ignore */}
                    <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={10}></UploadList>
                  </>
                  :
                  <table className="table project-wap-table">
                    <thead className="thead-project">
                      <tr>
                        <th className="tbl-header1">KPIs</th>
                        <th className="tbl-header2">In Scope</th>
                        <th className="tbl-header3">Condition</th>
                        <th className="tbl-header4">Status</th>
                        <th className="align-center">Comments</th>
                      </tr>
                    </thead>
                    <tbody className="tbody-project">
                      {/* LCS */}
                      <tr>
                        <td><span className="text-wgt--content">LCC In Scope</span></td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="lcsScope"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("lcsScope", val);
                                    clearErrors("lcsScope");
                                  }}
                                  options={lcsScopes}
                                  isError={!!errors.lcsScope}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <div className="select-project-down" style={{ flex: 1 }}>
                              <Controller
                                key={initialLcc ? "previousLcsCondition" : "lcsCondition"}
                                name={initialLcc ? 'previousLcsCondition' : 'lcsCondition'}
                                control={control}
                                render={({ field }) => (
                                  <SelectDropdown
                                    isDisabled={isDisabled}
                                    filterKey=""
                                    label=""
                                    value={field.value}
                                    onChange={(val) => {
                                      field.onChange(val);
                                      handleFilterChange(initialLcc ? "previousLcsCondition" : "lcsCondition", val);
                                      clearErrors(initialLcc ? "previousLcsCondition" : "lcsCondition");
                                    }}
                                    options={lcsConditions}
                                    isError={initialLcc ? !!errors.previousLcsCondition : !!errors.lcsCondition}
                                  />
                                )}
                              />
                            </div>
                            <IconButton
                              size="small"
                              onClick={reloadLcsConditions}
                              disabled={isDisabled}
                            >
                              <RefreshIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="lcsStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("lcsStatus", val);
                                    clearErrors("lcsStatus");
                                  }}
                                  options={lcsStatuses}
                                  isError={!!errors.lcsStatus}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-textarea">
                            <TextInput
                              isDisabled={isDisabled}
                              className="comment-input"
                              isComment={true}
                              onChange={(e) => handleFilterChange("lcsComment", e.target.value)}
                              name="lcsComment"
                              label=""
                              control={control}
                              errors={errors}
                              multiline
                            />
                          </div>
                        </td>
                      </tr>

                      {/* CPT */}
                      <tr>
                        <td><span className="text-wgt--content">CPT Parity</span></td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="cptScope"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("cptScope", val);
                                    clearErrors("cptScope");
                                  }}
                                  options={cptScopes}
                                  isError={!!errors.cptScope}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <div className="select-project-down">
                              <Controller
                                key={initialCpt ? "previouscptCondition" : "cptCondition"}
                                name={initialCpt ? 'previouscptCondition' : 'cptCondition'}
                                control={control}
                                render={({ field }) => (
                                  <SelectDropdown
                                    isDisabled={isDisabled}
                                    filterKey=""
                                    label=""
                                    value={field.value}
                                    onChange={(val) => {
                                      field.onChange(val);
                                      handleFilterChange(initialCpt ? "previouscptCondition" : "cptCondition", val);
                                      clearErrors(initialCpt ? "previouscptCondition" : "cptCondition");
                                    }}
                                    options={cptConditions}
                                    isError={initialCpt ? !!errors.previouscptCondition : !!errors.cptCondition}
                                  />
                                )}
                              />
                            </div>
                            <IconButton
                              size="small"
                              onClick={reloadCptConditions}
                              disabled={isDisabled}
                            >
                              <RefreshIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="cptStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("cptStatus", val);
                                    clearErrors("cptStatus");
                                  }}
                                  options={cptStatuses}
                                  isError={!!errors.cptStatus}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-textarea">
                            <TextInput
                              isDisabled={isDisabled}
                              className="comment-input"
                              isComment={true}
                              onChange={(e) => handleFilterChange("cptComment", e.target.value)}
                              name="cptComment"
                              label=""
                              control={control}
                              errors={errors}
                              multiline
                            />
                          </div>
                        </td>
                      </tr>

                      {/* D2D */}
                      <tr>
                        <td><span className="text-wgt--content">D2D Complete</span></td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="d2dScope"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("d2dScope", val);
                                    clearErrors("d2dScope");
                                  }}
                                  options={d2dScopes}
                                  isError={!!errors.d2dScope}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="d2dCondition"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("d2dCondition", val);
                                    clearErrors("d2dCondition");
                                  }}
                                  options={d2dConditions}
                                  isError={!!errors.d2dCondition}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="d2dStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("d2dStatus", val);
                                    clearErrors("d2dStatus");
                                  }}
                                  options={d2dStatuses}
                                  isError={!!errors.d2dStatus}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-textarea">
                            <TextInput
                              isDisabled={isDisabled}
                              className="comment-input"
                              isComment={true}
                              onChange={(e) => handleFilterChange("d2dComment", e.target.value)}
                              name="d2dComment"
                              label=""
                              control={control}
                              errors={errors}
                              multiline
                            />
                          </div>
                        </td>
                      </tr>

                      {/* LTCP (two Condition dropdowns) */}
                      <tr>
                        <td><span className="text-wgt--content">Proactive LTCP</span></td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="ltpcScope"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("ltpcScope", val);
                                    clearErrors("ltpcScope");
                                  }}
                                  options={ltpcScopes}
                                  isError={!!errors.ltpcScope}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-down" style={{ marginBottom: "10px" }}>
                            <Controller
                              name="ltpcLaunchYear"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={true}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("ltpcLaunchYear", val);
                                    clearErrors("ltpcLaunchYear");
                                  }}
                                  options={ltpcLaunchYear}
                                  isError={!!errors.ltpcLaunchYear}
                                />
                              )}
                            />
                          </div>
                          <div className="select-project-down">
                            <Controller
                              name="ltpcLaunchWeek"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("ltpcLaunchWeek", val);
                                    clearErrors("ltpcLaunchWeek");
                                  }}
                                  options={ltpcWeeks}
                                  isError={!!errors.ltpcLaunchWeek}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="ltpcStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("ltpcStatus", val);
                                    clearErrors("ltpcStatus");
                                  }}
                                  options={ltpcStatuses}
                                  isError={!!errors.ltpcStatus}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-textarea">
                            <TextInput
                              isDisabled={isDisabled}
                              className="comment-input"
                              isComment={true}
                              onChange={(e) => handleFilterChange("ltpcComment", e.target.value)}
                              name="ltpcComment"
                              label=""
                              control={control}
                              errors={errors}
                              multiline
                            />
                          </div>
                        </td>
                      </tr>

                      {/* DFMC */}
                      <tr>
                        <td><span className="text-wgt--content">DFM Complete</span></td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="dfmcScope"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("dfmcScope", val);
                                    clearErrors("dfmcScope");
                                  }}
                                  options={dfmcScopes}
                                  isError={!!errors.dfmcScope}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <div className="select-project-down">
                              <Controller
                                key={initialDfm ? "previousDfmcCondition" : "dfmcCondition"}
                                name={initialDfm ? 'previousDfmcCondition' : 'dfmcCondition'}
                                control={control}
                                render={({ field }) => (
                                  <SelectDropdown
                                    isDisabled={isDisabled}
                                    filterKey=""
                                    label=""
                                    value={field.value}
                                    onChange={(val) => {
                                      field.onChange(val);
                                      handleFilterChange(initialDfm ? "previousDfmcCondition" : "dfmcCondition", val);
                                      clearErrors(initialDfm ? "previousDfmcCondition" : "dfmcCondition");
                                    }}
                                    options={dfmcConditions}
                                    isError={initialDfm ? !!errors.previousDfmcCondition : !!errors.dfmcCondition}
                                  />
                                )}
                              />
                            </div>
                            <IconButton
                              size="small"
                              onClick={reloadDfmcConditions}
                              disabled={isDisabled}
                            >
                              <RefreshIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </td>
                        <td>
                          <div className="select-project-down">
                            <Controller
                              name="dfmcStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectDropdown
                                  isDisabled={isDisabled}
                                  filterKey=""
                                  label=""
                                  value={field.value}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    handleFilterChange("dfmcStatus", val);
                                    clearErrors("dfmcStatus");
                                  }}
                                  options={dfmcStatuses}
                                  isError={!!errors.dfmcStatus}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="select-project-textarea">
                            <TextInput
                              isDisabled={isDisabled}
                              className="comment-input"
                              isComment={true}
                              onChange={(e) => handleFilterChange("dfmcComment", e.target.value)}
                              name="dfmcComment"
                              label=""
                              control={control}
                              errors={errors}
                              multiline
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </table>

              }
            </div>
          </Box>

          {/* <form noValidate>
            <Grid container spacing={3}>
              <Grid size={12}>
                <h5 className="txt-mandatory-title">*Fields are mandatory</h5>
              </Grid>
              <Grid size={4}>
                <label className="txt-label-input">Freight Type<span className="required-txt"></span></label>
                <div className="project_drpdnw">
                  <Controller
                    name="freightType"
                    control={control}
                    render={({ field }) => (
                      <SelectDropdown
                        isDisabled={isDisabled}
                        filterKey=""
                        label=""
                        value={field.value}
                        onChange={(val) => {
                          field.onChange(val);
                          handleFilterChange("freightType", val);
                          clearErrors("freightType");
                        }}
                        options={freightTypes}
                        isError={!!errors.freightType}
                      />
                    )}
                  />
                </div>
                {errors.freightType && <p className="error-message">{errors.freightType.message}</p>}
              </Grid>


            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid size={8}>
                <label className="txt-label-input">Comment<span className="required-txt"></span></label>
                <TextInput isDisabled={isDisabled} className="comment-input" isComment={true} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
              </Grid>

            </Grid>

          </form> */}
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>
    </>
  );
};

export default KpiSummaryForm;